import axios from '@_system/axios/axios.js'
export default {
	path: '/BICompetitivegoods',
	search(data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/search', data, (res) => {
				resolve(res.data)
			}, reject)
		})
	}
}